import { Content } from "../types";
import DefaultContent from "./fr";

export const SUPPORTED_LANGUAGE = ["fr"] as const;

const contentList: Content[] = [];

const importContentFiles = async () => {
  for (let i = 0, n = SUPPORTED_LANGUAGE.length; i < n; i++) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const newContent: { default: Content } = await import(`./${SUPPORTED_LANGUAGE[i]}`);
    contentList.push(newContent.default);
  }
};

const getContent = async (lang: typeof SUPPORTED_LANGUAGE[number]): Promise<Content> => {
  if (contentList.length === 0) {
    await importContentFiles();
  }
  let content: Content = DefaultContent;
  if (contentList.length > 1) {
    for (let i = 0, n = contentList.length; i < n; i++) {
      const parsedContent: Content = contentList[i];
      if (parsedContent.language === lang) {
        content = parsedContent;
        break;
      }
    }
  }
  return content;
};

export default getContent;

export const defaultContent = DefaultContent;
